import { Surfaces } from "@netlify/sdk--ui-core";
import React from "react";
import { useNetlifySDK } from "../../use_netlify_sdk.js";

export type SiteLogsSurfaceProps = {
  className?: string | undefined;
  children?: React.ReactNode | undefined;
};

/**
 * A container element used to render the Project Logs surface. This component
 * will take care of styling your component so it looks good as a section
 * rendered under the logs navigation for projects in the Netlify UI.
 *
 * <!-- TODO(calebbarnes): Add a screenshot here -->
 *
 * @param props
 * @see Surfaces.SiteLogs
 * @example
 * ```tsx
 * import { SiteLogsSurface } from "@netlify/sdk/react/components";
 *
 * <SiteLogsSurface>
 *   <div>Your surface content goes here</div>
 * </SiteLogsSurface>
 * ```
 */
export const SiteLogsSurface = ({
  className,
  children,
  ...otherProps
}: SiteLogsSurfaceProps) => {
  const sdk = useNetlifySDK();

  return (
    <section
      id={`section-${Surfaces.SiteLogs}-${sdk.extension.slug}`}
      className={className}
      {...otherProps}
    >
      {children}
    </section>
  );
};
